import Focusable from 'components/focusable'
import styles from 'components/styles/app-error.css'
import { route } from 'preact-router'
import { Component } from 'react'
import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'

class AppError extends Component {
  constructor(props) {
    super(props)
    this.state = {
      networkIsDisconnected: this.isNetworkDisconnected(),
    }
    this.listenerId = null
  }

  componentDidMount() {
    if (typeof webapis !== 'undefined' && webapis.network) {
      this.listenerId = webapis.network.addNetworkStateChangeListener(
        this.onNetworkStateChangeListener
      )
    }
  }

  componentWillUnmount = () => {
    if (typeof webapis !== 'undefined' && webapis.network && this.listenerId !== null) {
      webapis.network.removeNetworkStateChangeListener(this.listenerId)
    }
  }

  isNetworkDisconnected = () => {
    if (typeof webapis !== 'undefined' && webapis.network) {
      return !webapis.network.isConnectedToGateway()
    } else {
      return false
    }
  }

  onNetworkStateChangeListener = value => {
    if (value === webapis.network.NetworkState.GATEWAY_DISCONNECTED) {
      this.setState({
        networkIsDisconnected: true,
      })
    } else if (value === webapis.network.NetworkState.GATEWAY_CONNECTED) {
      if (this.props.onClick) {
        this.props.onClick()
      } else {
        this.onBack()
      }
    }
  }

  onBack() {
    if (this.props.onBack) {
      this.props.onBack()
    } else {
      route(`${__webpack_public_path__ || '/'}`)
    }
  }

  exitApp() {
    if (typeof tizen !== 'undefined' && tizen.application) {
      tizen.application.getCurrentApplication().exit()
    } else {
      this.props.onBack()
    }
  }

  render({ title, message, buttonMessage, onClick, polyglot: { t } }) {
    if (this.state.networkIsDisconnected) {
      return (
        <div className={styles.appErrorComponent}>
          <div className={styles.message}>
            <div className={styles.title}>
              {t('tv_app.network_disconnected_title', {
                _: 'Network disconnected',
              })}
            </div>
            <div className={styles.body}>
              {t('tv_app.network_disconnected_content', {
                _:
                  'It looks like your network is currently disconnected. Please check your settings.',
              })}
            </div>
            <div onClick={this.exitApp} className={styles.btn}>
              {t('tv_app.button_close_app', { _: 'Exit application' })}
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className={styles.appErrorComponent}>
          <div className={styles.message}>
            {title && <div className={styles.title}>{title}</div>}
            <div className={styles.body}>
              {message ||
                t('checkout_app.default_error_msg', {
                  _: 'An error has occurred, please try again',
                })}
            </div>
            <div onClick={onClick} className={styles.btn}>
              {buttonMessage
                ? buttonMessage
                : t('checkout_app.button_dismiss', { _: 'Dismiss' })}
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  polyglot: getP(state),
})

export default connect(mapStateToProps)(AppError)
